import { Link } from 'react-router-dom';
import { useLang } from '../contexts/LanguageContext';

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-black text-white relative overflow-hidden">
      {/* Ligne top */}
      <div className="w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-12 md:pt-14 pb-8">

        {/* Logo centré */}
        <div className="text-center mb-8">
          <img src="/photos/Pernety_logo_fd_transparent.png" alt="Pernety"
            className="h-20 md:h-24 w-auto mx-auto"
            style={{ filter: 'invert(1) brightness(2)' }} />
        </div>

        {/* Grille 3 colonnes — centrée */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-8 lg:gap-12 mb-10 max-w-4xl mx-auto text-center">
          <div>
            <p className="text-[10px] tracking-[0.3em] uppercase mb-6 font-medium text-white/30">{t('footer.navigation')}</p>
            <div className="flex flex-col gap-4 items-center">
              <Link to="/" className="text-sm text-white/40 hover:text-white transition-colors duration-300">{t('nav.home')}</Link>
              <Link to="/la-maison" className="text-sm text-white/40 hover:text-white transition-colors duration-300">{t('nav.house')}</Link>
              <Link to="/collection" className="text-sm text-white/40 hover:text-white transition-colors duration-300">{t('nav.reverie')}</Link>
              <Link to="/notre-vision" className="text-sm text-white/40 hover:text-white transition-colors duration-300">{t('nav.fabrication')}</Link>
              <Link to="/contact" className="text-sm text-white/40 hover:text-white transition-colors duration-300">{t('nav.contact')}</Link>
            </div>
          </div>

          <div>
            <p className="text-[10px] tracking-[0.3em] uppercase mb-6 font-medium text-white/30">{t('footer.contact')}</p>
            <div className="flex flex-col gap-4 items-center">
              <p className="text-sm text-white/40">contact@pernetyparis.com</p>
            </div>
          </div>

          <div>
            <p className="text-[10px] tracking-[0.3em] uppercase mb-6 font-medium text-white/30">{t('footer.follow')}</p>
            <div className="flex flex-col gap-4 items-center">
              <a href="https://www.instagram.com/pernety_jewelry/" target="_blank" rel="noopener noreferrer"
                className="inline-flex items-center gap-3 text-sm text-white/40 hover:text-white transition-colors duration-300 group">
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
                @pernety_jewelry
              </a>
            </div>
          </div>
        </div>

        {/* Séparateur */}
        <div className="w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-8" />

        {/* Bottom */}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[11px] text-white/20 tracking-wider">
            &copy; {new Date().getFullYear()} Pernety Jewelry — {t('footer.rights')}
          </p>
          <div className="flex items-center gap-6">
            <Link to="/mentions-legales" className="text-[11px] text-white/20 hover:text-white/40 transition-colors tracking-wider">
              {t('nav.legal')}
            </Link>
            <span className="text-white/10">|</span>
            <Link to="/politique-confidentialite" className="text-[11px] text-white/20 hover:text-white/40 transition-colors tracking-wider">
              {t('nav.privacy')}
            </Link>
          </div>
        </div>
      </div>

      {/* Filigrane P en arrière-plan */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none select-none w-full text-center overflow-hidden">
        <p className="font-serif text-[8rem] sm:text-[12rem] md:text-[18rem] tracking-normal text-white/[0.015] leading-none">P</p>
      </div>
    </footer>
  );
}
